import * as React from 'react'
import { cn } from '../../lib/utils'

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
	({ className, ...props }, ref) => (
		<label
			ref={ref}
			className={cn(
				'text-sm font-medium leading-5 text-(--color-foreground)',
				className,
			)}
			{...props}
		/>
	),
)
Label.displayName = 'Label'

export { Label }
